export default __webpack_public_path__ + "4fd35c4ff83d8805bacf709b0b3cef04.svg";